import './fromscratch/style';
import FormStructure from './fromscratch/form_structure';

export default FormStructure;